/* eslint-disable max-len */
import * as React from 'react';
import styles from './text-icon.scss';
import { numericColorBrightness, hexColorToNumeric } from 'app/infrastructure/universal/color';

interface TextIconProps {
  className?: string;
  text?: string;
  bgColor?: string;
  color?: string;
}

export const TextIcon = (props: TextIconProps) => {
  const bgColor = props.bgColor || '#0f204b';
  const textColor = props.color || numericColorBrightness(hexColorToNumeric(bgColor)) < 128 ? '#fff' : '#000';

  return (
    <svg viewBox="0 0 20 20" height="10px" width="12px" className={props.className}>
      <path className={`${styles.tooltipArrow} tooltip-arrow`} fill={bgColor} d="M4,0H16L10,6Z" transform="translate(-4)" />
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill={bgColor} d="M 6.006 7.2 C 1.537 7.2 -1.257 12.038 0.978 15.909 C 3.213 19.78 8.799 19.78 11.034 15.909 C 11.544 15.026 11.812 14.025 11.812 13.006 L 11.812 13.006 C 11.811 9.8 9.212 7.201 6.006 7.2 Z" />
      <text fill={textColor} fontSize="9" x="6" y="16.3" textAnchor="middle" >{props.text}</text>
    </svg>);
};
